import { createTheme, PaletteColorOptions } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Theme {
    paletteCustom?: {
      google: PaletteColorOptions;
      facebook: PaletteColorOptions;
    };
  }
  // allow configuration using `createTheme`
  interface ThemeOptions {
    paletteCustom?: {
      google: PaletteColorOptions;
      facebook: PaletteColorOptions;
    };
  }
}

const theme = createTheme({
  palette: {
    mode: 'dark'
  },
  paletteCustom: {
    google: {
      main: '#dd4b39',
      light: '#e46f61',
      dark: '#be3221',
      contrastText: '#fff',
    },
    facebook: {
      main: '#3b5998',
      light: '#5375bc',
      dark: '#2f477a',
      contrastText: '#fff',
    },
  },
});

export default theme;
